module.exports = __webpack_public_path__ + "img/camera-web.ea33be7e.svg";